import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { catchError, Observable, of, take, tap } from 'rxjs';

export function initializeMsal(msalService: MsalService): () => Observable<AuthenticationResult | null | void> {
    return () => {
        return msalService.handleRedirectObservable().pipe(
            tap(() => {
                const accounts = msalService.instance.getAllAccounts();

                if (accounts.length > 0) {
                    const activeAccount = msalService.instance.getActiveAccount() || accounts[0];
                    msalService.instance.setActiveAccount(activeAccount);
                }
            }),
            catchError((error: unknown) => {
                console.error('Error during MSAL initialization:', error);
                return of(undefined);
            }),
            take(1)
        );
    };
}
